import { render, staticRenderFns } from "./addAndEditRole.vue?vue&type=template&id=d5a9f288&scoped=true"
import script from "./addAndEditRole.vue?vue&type=script&lang=js"
export * from "./addAndEditRole.vue?vue&type=script&lang=js"
import style0 from "./addAndEditRole.vue?vue&type=style&index=0&id=d5a9f288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a9f288",
  null
  
)

export default component.exports